import React, { Component } from 'react';

class Publications extends React.Component {
	render() {
		return (
			<div> 
			<p>
			[1] Study of Bayesian Neural Network: <a href="https://arxiv.org/abs/1801.07710"><button class="btn btn-primary">arXiv</button></a></p>
			<p>
			[2] Predicting the Present in Financial Markets Using the Wisdom of Crowds *In process to be published*
			</p>

			</div>
			);
	}
} 

export default Publications;







// WEBPACK FOOTER //
// ./src/writeups/publication.js